import { useState, useEffect, useRef } from 'react';
import { InputAdornment, InputLabel, IconButton, FormControl, OutlinedInput } from '@mui/material';

import SearchIcon from '@mui/icons-material/Search';

const DEBOUNCE_MS = 350;

const SearchBox = ({ value, setValue, searchRequest, placeholder }) => {
  const [localValue, setLocalValue] = useState(value);
  const debounceRef = useRef(null);

  useEffect(() => {
    setLocalValue(value);
    if (debounceRef.current) clearTimeout(debounceRef.current);
  }, [value]);

  const handleChange = (e) => {
    const newVal = e.target.value;
    setLocalValue(newVal);

    if (debounceRef.current) clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(() => {
      setValue(newVal);
    }, DEBOUNCE_MS);
  };

  useEffect(() => {
    return () => {
      if (debounceRef.current) clearTimeout(debounceRef.current);
    };
  }, []);

  const handleMouseDown = (event) => event.preventDefault();

  return (
    <FormControl variant="outlined" fullWidth>
      <InputLabel htmlFor="search">Search</InputLabel>
      <OutlinedInput
        type="text"
        value={localValue}
        onChange={handleChange}
        placeholder={placeholder}
        endAdornment={
          <InputAdornment position="end">
            <IconButton aria-label="search box" onClick={searchRequest} onMouseDown={handleMouseDown} edge="end">
              <SearchIcon />
            </IconButton>
          </InputAdornment>
        }
        label="Search"
        sx={{ fieldset: { borderRadius: '0 !important', borderBottom: 0 } }}
      />
    </FormControl>
  );
};

export default SearchBox;
